/** What waits on the person, from the one Needs you list every badge and Home read. */
export const needsYouCountOf = (inbox) => Number(inbox?.counts?.needs_you ?? inbox?.needs_you?.length ?? 0) || 0;
